export default {
  home: {
    title: '黑料不打烊 — 娱乐圈劲爆内幕全天候不停更',
    subtitle: '娱乐圈劲爆内幕全天候不停更',
    heroCta: '立即吃瓜',
    heroLearnMore: '了解更多',
    hotNews: '热门爆料',
    categories: '爆料分类',
    latestNews: '最新爆料',
    viewMore: '查看更多爆料',
    faq: '常见问题',
  },
  nav: {
    home: '首页',
    about: '关于我们',
  },
  footer: {
    copyright: '版权所有',
    disclaimer: '本站内容仅供娱乐参考，不构成任何投资或决策建议',
  },
};